function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Login Register
 *    Basic scripts for the login-register template. 
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/25
 */

import $ from 'jquery';
export var TEMPLATE_SELECTOR = '[data-login-register]';
export var RESET_PASSWORD_TOGGLE = '[data-reset-password-toggle]';
export var LOGIN_FORM_CONTAINER_SELECTOR = '[data-login-register-login]';
export var LOGIN_FORM_SELECTOR = '[data-login-form]';
export var LOGIN_FORM_TOGGLE = '[data-login-form-toggle]';
export var RESET_FORM_SELECTOR = '[data-reset-password-form]';
export var REGISTER_FORM_SELECTOR = '[data-login-register-register]';
export var REGISTER_FORM_SUBMIT = '[data-register-submit]';
export var REGISTER_FORM_PASSWORD = '[data-register-password]';
export var REGISTER_FORM_PASSWORD_CONFIRM = '[data-register-password-confirm]';
export var REGISTER_FORM_PASSWORD_ERROR = '[data-register-password-error]';
export var CLASS_VISIBLE = 'is-visible';
export var CLASS_ERROR = 'has-error';
var LoginRegister = /*#__PURE__*/function () {
  function LoginRegister(container) {
    var _this = this;
    _classCallCheck(this, LoginRegister);
    this.container = container;
    this.loginForm = container.find(LOGIN_FORM_SELECTOR);
    this.loginContainer = container.find(LOGIN_FORM_CONTAINER_SELECTOR);
    this.resetForm = container.find(RESET_FORM_SELECTOR);
    this.registerForm = container.find(REGISTER_FORM_SELECTOR);
    this.registerPassword = container.find(REGISTER_FORM_PASSWORD);
    this.registerPasswordConfirm = container.find(REGISTER_FORM_PASSWORD_CONFIRM);
    this.registerPasswordError = container.find(REGISTER_FORM_PASSWORD_ERROR);
    this.loginForms = [this.loginForm, this.resetForm];
    this.forms = [this.loginContainer, this.registerForm];
    container.on('click touchend', RESET_PASSWORD_TOGGLE, function (e) {
      return _this.onResetToggle(e);
    });
    container.on('click touchend', LOGIN_FORM_TOGGLE, function (e) {
      return _this.onFormsToggle(e);
    });
    container.on('click touchend', REGISTER_FORM_SUBMIT, function (e) {
      return _this.onFormSubmit(e);
    });
    this.onEmailNoFound();
  }
  _createClass(LoginRegister, [{
    key: "onEmailNoFound",
    value: function onEmailNoFound() {
      if (window.location.href.indexOf('#recover') !== -1) {
        this.loginForms.forEach(function (e) {
          return e.toggleClass(CLASS_VISIBLE);
        });
      }
    }
  }, {
    key: "onResetToggle",
    value: function onResetToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.loginForms.forEach(function (e) {
        return e.toggleClass(CLASS_VISIBLE);
      });
    }
  }, {
    key: "onFormsToggle",
    value: function onFormsToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.forms.forEach(function (e) {
        return e.toggleClass(CLASS_VISIBLE);
      });
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(e) {
      // Do we have a match?
      if (this.registerPassword.val() == this.registerPasswordConfirm.val()) return;
      // No match
      e.preventDefault();
      e.stopPropagation();
      this.registerPassword.addClass(CLASS_ERROR);
      this.registerPasswordConfirm.addClass(CLASS_ERROR);
      this.registerPasswordError.addClass(CLASS_VISIBLE);
    }
  }]);
  return LoginRegister;
}(); //Initialize
$(document).ready($(TEMPLATE_SELECTOR).each(function (e, i) {
  return new LoginRegister($(i));
}));